import { Component, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { icon, LatLng, latLng, marker, tileLayer } from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet.gridlayer.googlemutant';
import { DataService } from '../../../services/data.service';
import { ActivatedRoute } from '@angular/router';
import { catchError, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { TansportUiModel } from '../../trip/transport.ui.model';
import { CompanionUiModel } from '../../trip/companion.ui.model';
import { combineLatest, concat, Observable, of, Subject } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { StreetViewService } from '../../../services/street-view.service';
import { GeocodingService } from 'src/app/services/geocoding.service';
import { AppConfig } from 'src/app/app.config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorModalComponent } from '../../modals/error-modal/error-modal.component';

@Component({
  selector: 'app-edit-trip',
  templateUrl: './edit-trip.component.html',
  styleUrls: ['./edit-trip.component.scss']
})
export class EditTripComponent implements OnInit {

  public leafletOptions: any;
  public layers: any[];
  public data = [];
  public pageSize = 5;
  public page = 1;
  public selectedMode: string;
  public selectedRoute: any;
  public selectedTransport: TansportUiModel;
  public selectedSource: string;
  public selectedCompanions: CompanionUiModel[] = [];
  public selectedCompanionProfiles: string[] = [];

  public isPupil: boolean = false;

  private map: L.Map;
  public tiles = [];
  public currentTileIdx = 1;

  public center: LatLng = new LatLng(0, 0);

  private routeGroup: L.LayerGroup;
  private colors = {
    'SAFE': '#8cbf70',
    'OCCASIONALLY_UNSAFE': '#e8a453',
    'UNSAFE': 'red',
  };

  public modeToClass = {
    'foot': 'foots',
    'bike': 'bike',
    'moped': 'moto',
    'schoolbus': 'bus',
    'train': 'train',
    'bus_tram_metro': 'express',
    'car': 'car',
    'other': 'other',
  }

  role = 'management';

  address$: Observable<any[]>;
  addressLoading: boolean = false;
  addressInput$ = new Subject<string>();

  constructor(
    private service: DataService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private gsv: StreetViewService,
    private geocodingService: GeocodingService,
    private appConfig: AppConfig,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit() {

    this.activatedRoute
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.page = params['page'] || 1;
      });

    this.userService.getUserInfo().subscribe(user => { this.isPupil = user.attributes.userType.includes('PUPIL') });

    combineLatest([this.activatedRoute.params, this.activatedRoute.data]).pipe(
      map(([params, data]) => {
        this.role = data.role || this.role;
        console.log('role', this.role);
        return params.id;
      }),
      switchMap(id => this.service.getRoute(id)),
      map(routes => routes[0]),
      tap(route => {
        this.selectedRoute = route;
        this.selectedTransport = this.findTransport(route.genericAttributes.attributes.mode[0]);
        this.selectedSource = this.findSource(route.genericAttributes.attributes.mode[0]);
        this.selectedCompanions = (route.genericAttributes.attributes.child_travel_companions || []).map(c => this.findCompanion(c));
        console.log(this.selectedCompanions)
        this.selectedCompanionProfiles = this.selectedCompanions.map(c => c.profile.toUpperCase());
      }),

    ).subscribe(route => this.drawRoute(route));

    const tileLayerOptions = {
      maxZoom: 18,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoiYW50b242Mzc4IiwiYSI6IlBtMG5pMjgifQ.bGiCZKEStTnO5YjSzmkJZg'
    };

    this.tiles = [
      // tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', tileLayerOptions),
      // @ts-ignore
      L.gridLayer.googleMutant({ type: 'satellite' }),
      this.appConfig.getTileLayer()
    ];

    this.leafletOptions = {
      layers: [
        this.tiles[1]
      ],
      zoom: 14,
      center: latLng(50.848656786354994, 4.349341392517091)
    };

    this.initTypeahead();
  }

  initTypeahead() {
    const project_location = localStorage.getItem('project_location');
    this.address$ = concat(
      of([]),
      this.addressInput$.pipe(
        distinctUntilChanged(),
        tap(() => this.addressLoading = true),
        switchMap(term => {
          if (term) {
            console.log(this.map.getCenter());
            let latlng;
            if (!project_location) { latlng = this.map.getCenter(); }
            else {
              const locations = project_location.split(',');
              var latitude = parseFloat(locations[1]),
                longitude = parseFloat(locations[0]);
              latlng = L.latLng(latitude, longitude);
            }
            return this.geocodingService.addressAutocomplete(term, latlng.lat, latlng.lng).pipe(
              catchError(() => of([])),
              map(result => {
                if (result.features) return result.features.map(r => Object.assign(r.properties, r.geometry));
                else return [];
              }),
              tap(() => this.addressLoading = false)
            );
          }
          this.addressLoading = false;
          // return of([]).pipe(
          //   map(() => this.addressLoading = false)
          // );
        })
      )
    )
  }

  findPos(latlng) {
    this.map.panTo({ lng: latlng.lon ? latlng.lon : latlng.lng, lat: latlng.lat });
    this.map.setZoom(18);
  }

  onInputAddress(event) {
    console.log('input', event);
    if (event.coordinates) {
      const latlng = L.latLng(event.coordinates[1], event.coordinates[0]);
      this.findPos(latlng);
    }
    else if (event.name) {
      this.geocodingService.findPosition(event.name).subscribe(response => {
        if (response && response.lat) this.findPos(response);
      }, err => {
        const errDlg = this.modalService.open(ErrorModalComponent);
        errDlg.componentInstance.header = 'Unknown address';
        errDlg.componentInstance.message = 'The location of this address could not be determined. Please enter a new address.';
      });
    }
  }

  toggleMapType() {
    try {
      this.tiles[this.currentTileIdx].removeFrom(this.map);
    } catch { }
    // this.currentTileIdx = this.currentTileIdx == 2 ? 0 : this.currentTileIdx + 1;
    this.currentTileIdx = this.currentTileIdx == 1 ? 0 : this.currentTileIdx + 1;
    this.tiles[this.currentTileIdx].addTo(this.map);
  }

  public updateMode(mode) {
    this.service
      .updateRouteMode(this.selectedRoute.entityID.id2, mode, this.selectedRoute.projectID.id)
      .subscribe(() => {
        this.selectedMode = mode;
        this.selectedTransport = this.findTransport(mode);
        this.selectedRoute.genericAttributes.attributes.mode = [mode];
      });
  }

  public updateCompanions(companion) {
    const includesAlone = this.selectedCompanionProfiles.includes('ALONE');
    const isAlone = companion.toUpperCase() === 'ALONE';

    let selectedCompanions = this.selectedCompanionProfiles;

    if ((includesAlone && !isAlone) || (!includesAlone && isAlone)) {
      selectedCompanions = [companion];
    } else {
      if (selectedCompanions.includes(companion)) {
        selectedCompanions = selectedCompanions.filter(c => c !== companion);
      } else {
        selectedCompanions.push(companion);
      }
    }

    this.service
      .updateRouteCompanions(this.selectedRoute.entityID.id2, selectedCompanions, this.selectedRoute.projectID.id)
      .subscribe(() => {
        this.selectedCompanions = selectedCompanions.map(c => this.findCompanion(c));
        this.selectedCompanionProfiles = selectedCompanions;
      });
  }

  public onMapReady(event: L.Map) {
    this.map = event;
  }

  private drawRoute(route) {
    if (this.routeGroup) {
      this.map.removeLayer(this.routeGroup);
    }
    this.routeGroup = new L.LayerGroup<L.Polyline | L.Marker>();
    this.selectedMode = route.genericAttributes.attributes.mode[0];
    this.selectedRoute = route;

    let allCoords = [];
    route.segments.forEach(segment => {
      const attrs = segment.genericAttributes.attributes;
      const key = attrs.accessibility[0];
      const polyline = this.poly(attrs, this.colors[key]);
      const coords = attrs.geometry[0].coordinates.map(coordinates => L.latLng(coordinates[1], coordinates[0]));
      allCoords = allCoords.concat(coords);
      this.routeGroup.addLayer(polyline);
    });

    const homeMarker = L.marker(allCoords[0], {
      icon: L.icon({
        iconUrl: 'assets/marker/home.png',
        iconSize: [57, 67],
        iconAnchor: [27, 66]
      })
    });
    const officeMarker = L.marker(allCoords[allCoords.length - 1], {
      icon: L.icon({
        iconUrl: 'assets/marker/office.png',
        iconSize: [57, 67],
        iconAnchor: [27, 66]
      })
    });

    homeMarker.bindTooltip(
      `${this.userService.user.attributes.address[0].street} ${this.userService.user.attributes.address[0].houseNumber}`
    );

    this.routeGroup.addLayer(homeMarker);
    this.routeGroup.addLayer(officeMarker);
    this.map.addLayer(this.routeGroup);
    this.map.fitBounds(allCoords);
  }

  private poly(attr: any, color: string) {
    const coords = attr.geometry[0].coordinates.map(coords => [coords[1], coords[0]]);
    return L.polyline(coords, {
      color,
    });
  }

  private findCompanion(code: string): CompanionUiModel {
    switch (code) {
    case 'ALONE':
      return {
        id: 1,
        type: 'alone',
        img: 'assets/svg/companions/1.svg',
        profile: 'alone',
      };
    case 'FRIENDS':
      return {
        id: 3,
        type: 'friends',
        img: 'assets/svg/companions/2.svg',
        profile: 'friends',
      };
    case 'ADULTS':
      return {
        id: 2,
        type: 'adults',
        img: 'assets/svg/companions/3.svg',
        profile: 'adults',
      };
    }
  }

  private findTransport(code: string): TansportUiModel {
    switch (code) {
      case 'FOOT':
        return {
          id: 1,
          profile: 'FOOT',
          type: 'foot',
          transport: 'FOOT',
          img: 'assets/svg/transports/1.svg'
        };
      case 'BIKE':
        return {
          id: 1,
          profile: 'BIKE',
          type: 'bicycle',
          transport: 'BIKE',
          img: 'assets/svg/transports/2.svg'
        };
      case 'MOPED':
        return {
          id: 1,
          profile: 'MOPED',
          type: 'bicycle',
          transport: 'MOPED',
          img: 'assets/svg/transports/3.svg'
        };
      case 'SCHOOLBUS':
        return {
          id: 1,
          profile: 'SCHOOLBUS',
          type: 'bike',
          transport: 'SCHOOLBUS',
          img: 'assets/svg/transports/4.svg'
        };
      case 'TRAIN':
        return {
          id: 1,
          profile: 'TRAIN',
          type: 'bike',
          transport: 'TRAIN',
          img: 'assets/svg/transports/5.svg'
        };
      case 'BUS_TRAM_METRO':
        return {
          id: 1,
          profile: 'BUS_TRAM_METRO',
          type: 'car',
          transport: 'BUS_TRAM_METRO',
          img: 'assets/svg/transports/6.svg'
        };
      case 'CAR':
        return {
          id: 1,
          profile: 'CAR',
          type: 'car',
          transport: 'CAR',
          img: 'assets/svg/transports/7.svg'
        };
      case 'OTHER':
        return {
          id: 1,
          profile: 'OTHER',
          type: 'car',
          transport: 'OTHER',
          img: 'assets/svg/transports/8.svg'
        };
    }
  }

  private findSource(code: string) {
    switch (code) {
      case 'WEBSITE':
        return 'assets/svg/Trip_Upload_2.svg';
      default:
        return 'assets/svg/Trip_Upload_1.svg'
    }
  }
}
